// extracted by mini-css-extract-plugin
export default {"ellipseIcon":"DepartmentIcon_ellipseIcon__01ckP","buildingIcon":"DepartmentIcon_buildingIcon__G2P-J","buildingIconDiv":"DepartmentIcon_buildingIconDiv__3uYGQ"};